import Http from '../services/http.service';

const Slack = {};
Slack.channels = async () => (await Http.get().get(`${process.env.VUE_APP_API}/1/slack/channels`)).data;
Slack.install = async (code) => (await Http.get().post(`${process.env.VUE_APP_API}/1/slack/install`, {code})).data;
export default Slack;
